<template>
  <div class="section -less-pad -center">
    <h1 class="section__header">{{ $t('not-found.title') }}</h1>
    <p class="section__text">{{ $t('not-found.description') }}</p>
    <LangRouterLink :to="{ name: 'home' }" class="button -right section__button">
      <span>{{ $t('not-found.home') }}</span>
      <span class="button__icon">
        <Icon id="arrow" />
      </span>
    </LangRouterLink>
  </div>

  <SectionSwiperVoyages
    v-if="voyages"
    :destinations="voyages"
    :title="$t('not-found.trips.title')"
    :description="$t('not-found.trips.description')"
  />
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import SectionSwiperVoyages from '@/components/sections/SectionSwiperVoyages.vue'

export default {
  name: 'NotFound',
  components: { Icon, LangRouterLink, SectionSwiperVoyages },
  computed: {
    voyages() {
      if (!this.$beet.destinations) return null
      return this.$beet.destinations.slice(0, 6).map(({ id }) => id)
    },
  },
}
</script>
